<template>
  <div class="tax-information hour-salary">
    <div class="tax-head">
      <h1>Salary Report Lists</h1>
    </div>

    <div class="searchbar-holder">
      <div class="search-bar">
        <div class="input-wrapper">
        </div>
      </div>
      <div class="creat-newbtn">
        <router-link  class="btn btn-primary" :to="{ path: '/salary-calculator' }">
          Create New
        </router-link>
      </div>
    </div>
    <div class="table-scroll">
      <table class="table">
        <thead class="table-head">
          <tr>
            <th scope="col">Period</th>
            <th class="text-right" scope="col">Employees</th>
            <th class="text-right" scope="col">Total Salary</th>
            <th class="text-right" scope="col">Tax</th>
            <th class="text-right">NET PAYABLE</th>
            <th>ACTIONS</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(employee, idx) in info" :key="idx">
            <td>
              {{ employee.from_date | formatDate2 }} -
              {{ employee.to_date | formatDate2 }} - <strong>{{ employee.from_date | moment("MMM") }}</strong>
            </td>
            <td class="text-right">{{ employee.employee_count }}</td>
            <td class="text-right">{{ currencyFormatter2(employee.total_salary) }}</td>
            <td class="text-right">{{ currencyFormatter2(employee.tax) }}</td>
            <td class="text-right">{{ currencyFormatter2(employee.netAmount) }}</td>
            <td class="action-btn">
              <router-link :to="'/salary-calculator/'+employee.id" v-if="employee.is_lock === false"  class="pointer" style="cursor: pointer" >
                <i class="ico ico-pencil"></i>
              </router-link>
              <a href="javascript:void(0)" class="edit-icon flex-shrink-0 pl-2"
              data-toggle="modal"
              data-target="#lockView-modal"
              @click="getSalaryByPeriod(employee.id)">
                <i class="ico-sec ico-eye_selected"></i>
              </a>
              <a v-if="employee.is_lock === false"><i class="ico ico-lock-open"></i></a>
              <a v-if="employee.is_lock === false"   @click="deleteSalaryByPeriod(employee.id)" ><i class="ico ico-delete"></i></a>
              <a v-else><i class="ico ico-lock"></i> </a>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- lock detail view modal -->
      <div
      class="modal fade write-msg-model creat-employee-modal"
      id="lockView-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="write-msg-modelLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title">
              <header class="model-heading">
                <h1>Salary View</h1>

                <div class="bonus-deduct">
                  <strong>From</strong>
                  {{ new Date(salaryCalculationByPeriod.from_date).toDateString() }}
                  <strong>To</strong>
                  {{ new Date(salaryCalculationByPeriod.to_date).toDateString() }}
                </div>
              </header>
            </div>
              <button
              type="button"
              class="close"
              ref="closeModal"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span class="ico-cross"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="table-scroll salary-calculation">
					<table class="table" id="tblData">
						<thead class="table-head">
							<tr>
								<th scope="col">#</th>
								<th scope="col">Employee</th>
								<th scope="col" class="text-right">Monthly Salary</th>
								<th scope="col" class="text-right" >Allowances/Bonuses</th>
								<th scope="col" class="text-right" >Deductions</th>
								<th scope="col" class="text-right" >Tax</th>
								<th scope="col" class="text-right" >NET PAYABLE</th>

							</tr>
						</thead>
						<tbody>
							<tr v-for="(salary,index) of salaryCalculationByPeriod.salaryCalculations" :key="index" class="text-center">
								<td>{{ index+1 }}</td>
								<td class="text-capitalize"><a href="javascript:void(0);" @click="redirectToProfile(salary.user)">{{ salary.user.name }}</a></td>
								<td class="text-right" >{{ currencyFormatter2(salary.basic_salary) }}</td>
								<td class="text-right" >{{ currencyFormatter2(salary.allownces) }}</td>
								<td class="text-right" >{{ currencyFormatter2(salary.deductions) }}</td>
								<td class="text-right" >{{ currencyFormatter2(salary.tax) }}</td>
								<td class="text-right" > {{ currencyFormatter2((salary.basic_salary + salary.allownces - salary.deductions -salary.tax)) }} </td>
							</tr>
							<tr>
                <td></td>
								<td class="text-right" colspan="5">Total</td>
								<td class=""><strong>{{ currencyFormatter2(sumOfAmount) }}</strong></td>
							</tr>
						</tbody>
					</table>
				</div>
          </div>
          <div class="modal-footer">
            <a v-on:click="ExportXLSX()" class="btn btn-info text-right">Generate CSV</a>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "salarylist",

  components: {},
  data() {
    return {
      company_id: this.$store.getters.getSelectedCompany.id,
      info: null,
      currency:this.$store.getters.getSelectedCompany.currency,
      salaryCalculationByPeriod:[],
      allSalaryPeriods:[],
      sumOfAmount:0
    };
  },
  serverPrefetch() {
    // return this.addCompany();
  },
  mounted() {
    this.showsalary();
    this.getAllSalaryPeriods();
  },
  updated(){
  },
  created() {
    this.getCompanyTaxSlab();
  },
  methods: {
    getCompanyTaxSlab(){
      let params = {
        company_id: this.company_id,
      };
      this.$axios.get(this.$CompanyCurrentTaxSlabs, {
        params: params,
        headers: this.getAuthHeader()
      }).then(response => {
        if(response.data.status==200){
          let taxSlab = response.data.result || [];
          localStorage.setItem('companyTaxSlab', JSON.stringify(taxSlab));
        }
      })
        .catch(error => {
          console.log(error);
        })
    },
    currencyFormatter2(value){
     return this.currencyFormatter(value);
    },
    redirectToProfile(user){
      $('#lockView-modal').modal('hide');
      this.$router.push({path:'/employee/profile/'+ user.uuid});
    },
    deleteSalaryByPeriod(id){
      let params = { company_id: this.company_id,id:id };
      this.$axios({
        method: "get",
        params: params,
        url: this.$DeleteSalaryPeriods,
        headers: this.getAuthHeader(),
      }).then(res => {
        if (res.data.status == 200) {
          $root.$toast.success("Successfully Deleted");
          this.showsalary();
          this.getAllSalaryPeriods();
        }
      });
    },
    getSalaryByPeriod(id){
      this.sumOfAmount = 0;
      this.salaryCalculationByPeriod = this.allSalaryPeriods.filter(item => item.id === id);
      this.salaryCalculationByPeriod = this.salaryCalculationByPeriod[0];
      this.salaryCalculationByPeriod.salaryCalculations.map(item => {
        this.sumOfAmount += (item.basic_salary + item.allownces - item.deductions - item.tax);
      })
    },
    ExportXLSX() {
        this.isHidden = true;
        var tab_text = "<table border='2px'><tr bgcolor='#87AFC6'>";
        var textRange;
        var j = 0;
        var tab = document.getElementById("tblData");
        for (j = 0; j < tab.rows.length; j++) {
          var row = tab.rows[j];
          var numberOfCells = row.cells.length;
          tab_text = tab_text + tab.rows[j].innerHTML + "</tr>";
        }
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
          txtArea1.document.open("txt/html", "replace");
          txtArea1.document.write(tab_text);
          txtArea1.document.close();
          txtArea1.focus();
          sa = txtArea1.document.execCommand("SaveAs", true, "Thanks.xls");
        } else {
          let a = $("<a />", {
            href:
              "data:application/vnd.ms-excel," + encodeURIComponent(tab_text),
            download: "SalaryCalculations.xls",
          })
            .appendTo("body")
            .get(0)
            .click();
        }
    },

    showsalary() {
      let params = { company_id: this.company_id };
      this.$axios
        .get(this.$SalaryList, {
          params: params,
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          this.info = Object.values(response.data.result).reverse();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    editSalary(from_date, to_date) {
      var from_datee = moment(from_date).format("YYYY-MM-DD");
      var to_datee = moment(to_date).format("YYYY-MM-DD");

      this.$router.push({ name: "salary-calculator" });
    },

    getAllSalaryPeriods(){
      this.$axios({
        method: "get",
        url: this.$GetSalaryPeriods,
        headers: this.getAuthHeader()
      }).then(res => {
        if (res.data.status == 200) {
          this.allSalaryPeriods = res.data.result;
        }
      });
    }
  },
};
</script>

<style scoped>
.modal-lg, .modal-xl {
    max-width: 1240px !important;
}
.creat-employee-modal .modal-header {
    border-bottom: 0px solid #ccc !important;
}
.modal-footer{
  border-top: 0px solid #dee2e6 !important;
}
</style>
